import React from 'react';
import { Table, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const formatNumber = (value, fallback = 0) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : fallback;
};

const formatPoints = (points) => formatNumber(points).toFixed(2);

const getRankClass = (index) => {
  if (index === 0) return 'is-first';
  if (index === 1) return 'is-second';
  if (index === 2) return 'is-third';
  return '';
};

const LeagueStandingsTable = ({ title, teams }) => {
  if (!teams || teams.length === 0) {
    return (
      <Card className="standings-card is-empty">
        <Card.Body>
          <strong>{title}</strong>
          <p>Không có dữ liệu cho bảng này.</p>
        </Card.Body>
      </Card>
    );
  }

  const totalPlayed = teams.reduce((total, team) => total + formatNumber(team.played), 0);

  return (
    <Card className="standings-card">
      <Card.Header className="standings-card-header">
        <div>
          <span>Bảng đấu</span>
          <h2>{title}</h2>
        </div>
        <div className="standings-card-summary">
          <strong>{teams.length}</strong>
          <span>đội</span>
          <small>{totalPlayed} trận</small>
        </div>
      </Card.Header>
      <Card.Body className="standings-card-body">
        <div className="standings-table-wrap">
          <Table hover className="standings-table">
            <thead>
              <tr>
                <th>Hạng</th>
                <th className="text-start">Đội</th>
                <th>Trận</th>
                <th className="d-none d-md-table-cell">Thắng</th>
                <th className="d-none d-md-table-cell">Thua</th>
                <th>Điểm</th>
              </tr>
            </thead>
            <tbody>
              {teams.map((team, index) => {
                const rankClass = getRankClass(index);
                const wins = formatNumber(team.wins);
                const losses = formatNumber(team.losses);

                return (
                  <tr key={team.team_id || `${team.name}-${index}`}>
                    <td>
                      <span className={`standings-rank ${rankClass}`}>
                        {index + 1}
                      </span>
                    </td>
                    <td className="standings-team-cell">
                      <Link
                        to={`/teams/${team.team_id}`}
                        className="standings-team-link"
                      >
                        <span className="standings-team-name">{team.name}</span>
                        <span className="standings-team-record d-md-none">
                          Thắng {wins} · Thua {losses}
                        </span>
                      </Link>
                    </td>
                    <td className="standings-number">{formatNumber(team.played)}</td>
                    <td className="standings-number is-win d-none d-md-table-cell">{wins}</td>
                    <td className="standings-number is-loss d-none d-md-table-cell">{losses}</td>
                    <td>
                      <span className="standings-points">{formatPoints(team.points)}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default LeagueStandingsTable;
